import { isProduction } from './helpers/envHelper';
import { ErecruitingSourcingServiceProductType } from './interfaces/xingOne';

export const DEBOUNCE_TIME = 350;
export const MUTATION_FEEDBACK_TIME = 3000;

export const AUTOCOMPLETE_MIN_CHARS = 2;

export const CLOSE_DELAY = 100;

export const FORM_WIDTH = 672;
export const VIEW_WITHOUT_SIDEBAR_WIDTH = 1136;

export const PROGRESS_STEP_WAITING = 'Waiting';
export const PROGRESS_STEP_CANCELLED = 'Abgebrochen';
export const PROGRESS_STEP_CONSULTANT_ASSIGNED = 'Briefinggespräch mit XING';
export const PROGRESS_STEP_FIRST_SCREENING = 'Kandidatensuche und -ansprache';
export const PROGRESS_STEP_INITIAL_REVIEW = 'Kandidateninterviews';
export const PROGRESS_STEP_SECOND_SCREENING = 'XING wartet auf Ihr Feedback';
export const PROGRESS_STEP_FINAL = 'Kandidatenpräsentation abgesch';
export const WORKFLOW_STATUS = {
  UNASSIGNED: 'UNASSIGNED',
  CONSULTANT_ASSIGNED: 'CONSULTANT_ASSIGNED',
  FIRST_SCREENING: 'FIRST_SCREENING',
  INITIAL_REVIEW: 'INITIAL_REVIEW',
  ACTIVE_SOURCING: 'ACTIVE_SOURCING',
  SECOND_SCREENING: 'SECOND_SCREENING',
  FINAL_PRESENTATION: 'FINAL_PRESENTATION',
  CANCELLED: 'CANCELLED',
};

const SHORTLIST_PROGRESS_STEPS = {
  [WORKFLOW_STATUS.CANCELLED]: -1,
  [WORKFLOW_STATUS.UNASSIGNED]: 0,
  [WORKFLOW_STATUS.CONSULTANT_ASSIGNED]: 1,
  [WORKFLOW_STATUS.FIRST_SCREENING]: 2,
  [WORKFLOW_STATUS.INITIAL_REVIEW]: 3,
  [WORKFLOW_STATUS.SECOND_SCREENING]: 4,
  [WORKFLOW_STATUS.FINAL_PRESENTATION]: 5,
};

const LONGLIST_PROGRESS_STEPS = {
  [WORKFLOW_STATUS.CANCELLED]: -1,
  [WORKFLOW_STATUS.UNASSIGNED]: 0,
  [WORKFLOW_STATUS.CONSULTANT_ASSIGNED]: 1,
  [WORKFLOW_STATUS.FIRST_SCREENING]: 2,
  [WORKFLOW_STATUS.ACTIVE_SOURCING]: 3,
  [WORKFLOW_STATUS.FINAL_PRESENTATION]: 4,
};

export const PROGRESS_STEPS = (
  productType: ErecruitingSourcingServiceProductType,
) => {
  return productType === ErecruitingSourcingServiceProductType.Longlist
    ? LONGLIST_PROGRESS_STEPS
    : SHORTLIST_PROGRESS_STEPS;
};

export const SHORTLIST_TOTAL_PROGRESS_STEPS = 5;
export const LONGLIST_TOTAL_PROGRESS_STEPS = 4;
export const TOTAL_PROGRESS_STEPS = (
  productType: ErecruitingSourcingServiceProductType,
) => {
  return productType === ErecruitingSourcingServiceProductType.Longlist
    ? LONGLIST_TOTAL_PROGRESS_STEPS
    : SHORTLIST_TOTAL_PROGRESS_STEPS;
};

export const ACTIVE_COMPANY_ID = 'active_company_id';

export const FEATURE_SWITCHES = {
  TRACKING_ENABLED: 'xss_tracking_enabled',
  RECRUITING_SETTINGS: 'recruiting_settings_your_settings',
  QUICK_FEEDBACK_ENABLED: 'xts_easy_feedback_in_briefing',
  NEW_BRIEFING_DETAILS_ENABLED: 'xts_new_briefing_details',
  NEW_BRIEFING_FORM_ENABLED: 'xts_new_briefing_form',
  XING_REBRANDING_ENABLED: 'dev_flag_xing_rebranding',
} as const;

export const PHONE_REGEX =
  /^(\({0,1}|\+{0,1}[0-9]{1,4}\){0,1}\s{0,1}\-{0,1}[0-9]{1,4}\s{0,1}\-{0,1})*([0-9]{1,4})$/;

export const LOCALE_EN = 'en';
export const LOCALE_DE = 'de';
export const LOCALE_ES = 'es';

export const PRODUCT_NAME = 'xts';

export const BRIEFING_CARD_STATUS_COLOURS = {
  pending: 'grey100',
  completed: 'pigeon',
  full: 'success',
  cancelled: 'xtp',
};

export const BRIEFING_STATUS_KEYS = {
  '-1': 'XSS_BRIEFING_STATUS_CANCELLED',
  0: 'XSS_BRIEFING_STATUS_WAITING',
  1: 'XSS_BRIEFING_STATUS_CONSULTANT_ASSIGNED',
  2: 'XSS_BRIEFING_STATUS_FIRST_SCREENING',
  3: 'XSS_BRIEFING_STATUS_INITIAL_REVIEW',
  4: 'XSS_BRIEFING_STATUS_SECOND_SCREENING',
  5: 'XSS_BRIEFING_STATUS_FINAL',
};

export const MAX_CHARS_PILLS = 20;
export const DEFAULT_COMPANY_LOGO =
  '/assets/companies/img/default-logo_48x48.png';

export const DEFAULT_COMPANY_LOGO_URL = isProduction()
  ? `https://www.xing.com${DEFAULT_COMPANY_LOGO}`
  : `https://preview.xing.com${DEFAULT_COMPANY_LOGO}`;

export const XTS_EMAIL = 'talentservice@xing.com';

export const ONBOARDING_WIDTH = 800;

export const CONSUMER_APP = 'erecruiting-sourcing-service';

export const MAX_USERS_TO_SHARE = 18;

export const LOGIN_TRACK_PAGE_NAME = 'wbxts/Automatic_Recruiting/login';
export const MINIMUM_NUMBER_OF_SKILLS = 3;

export const ONBOARDING_FORM_LINK =
  'https://www.youtube.com/watch?v=lT0UFfVYt8U';

export enum PRODUCT_TYPES {
  longlist = 'longlist',
  shortlist = 'shortlist',
}

export const LONGLIST_PRICE = 2990;
export const SHORTLIST_PRICE = 6490;

export const SHORTLIST_FEEDBACK_ULR =
  'https://feedback.xing.com/umfrage/1543634/LEuO6p';
export const LONGLIST_FEEDBACK_ULR =
  'https://feedback.xing.com/umfrage/1543634/LEuO6p';
export const SHORTLIST_HOW_TO_VIDEO_ULR =
  'https://www.youtube.com/watch?v=nO9HT_Coubw';

export const MAX_SELECTED_SKILLS = 10;
